import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import AdmicityTableV2 from '../../../shared-components/Table/V2/AdmicityTableV2';
import {useGetEmployeeGroupsQuery} from '../../../api/services/employeeService';
import useNotification from '../../../utility/hooks/useNotification';

const columns = [
    {
        accessorKey: 'name',
        header: 'Group Name'
    }
];

// Maria, 19 October 2026: the groups of staff the member of staff is in, as the student Groups tab lists a child's
const EmployeeGroupsTab = () => {
    const {id} = useParams();
    const {data = [], isLoading, isError, error} = useGetEmployeeGroupsQuery(id);
    const {showErrorNotification} = useNotification();

    useEffect(() => {
        if (isError) {
            showErrorNotification(error?.message ?? '');
        }
    }, [isError]);

    return (
        <AdmicityTableV2
            columns={columns}
            data={data}
            isLoading={isLoading}
            tableProps={{
                enableSorting: false,
                enableColumnResizing: false,
                enableRowActions: false,
                enableBottomToolbar: false,
                enableTopToolbar: false,
                muiTableBodyRowProps: {hover: false},
                manualFiltering: false,
                enablePagination: false,
                manualSorting: false,
                enableHiding: false,
                muiTableContainerProps: {sx: {flex: '0 0 auto'}}
            }}
        />
    );
};

export default EmployeeGroupsTab;
